/* =====================================================================
 * CNM Product Hero — interactivity (Size × Pack bundle picker)
 * Vanilla JS, no dependencies. Initialises for each [data-cnm-hero].
 *
 * Model: two independent choices combine into one variant —
 *   • Size  (Option 1): "Original (2 Small, 2 Large)" / "Small (4 Small)" / "Large (4 Large)"
 *   • Pack  (Option 2): "1 Pack" / "2 Packs" / "3 Packs"
 *
 * DOM contract (rendered by sections/cnm-product-hero.liquid):
 *   [data-cnm-variants]      <script type=application/json> array of
 *                            {id, size, pack, price(pennies), available}
 *   [data-cnm-size]          size buttons; attr value = Option-1 value, .is-active
 *     [data-cnm-hint]         per-size fit hint text (mirrored into the hint line)
 *   [data-cnm-fit-hint]       the adaptive fit-hint line under the size selector
 *   [data-cnm-pack]          pack cards;  attr value = Option-2 value, .is-selected
 *     [data-cnm-card-price]   filled with the pack price
 *     [data-cnm-card-perpack] filled with "£X.XX/pack"
 *     [data-cnm-card-save]    filled with "SAVE N%" (computed from live prices)
 *   [data-cnm-variant-input]  hidden <input name=id>
 *   [data-cnm-price-display]  ATC price label
 *   subscribe: [data-cnm-sub-toggle/checkbox/pill], [data-cnm-sellingplan-input]
 *
 * Prices come straight from Shopify variant data, so per-pack + savings are
 * always truthful. Subscription discount below is a VISUAL preview only — the
 * real discount is whatever the Shopify Subscriptions selling plan is set to.
 * ===================================================================== */

(function () {
  'use strict';

  var SUB_DISCOUNT = 0.20; // visual preview only (selling plan is source of truth)

  function money(pennies) {
    return '£' + (Math.round(pennies) / 100).toFixed(2);
  }
  function packCount(label) {
    var m = String(label).match(/\d+/);
    return m ? parseInt(m[0], 10) : 1;
  }

  function initHero(root) {
    var form = root.querySelector('[data-cnm-bundle-form]');
    if (!form) return;

    var variants = [];
    var dataEl = form.querySelector('[data-cnm-variants]');
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    var variantInput     = form.querySelector('[data-cnm-variant-input]');
    var sellingPlanInput = form.querySelector('[data-cnm-sellingplan-input]');
    var priceDisplay     = form.querySelector('[data-cnm-price-display]');
    var youPay           = form.querySelector('[data-cnm-youpay]');
    var subToggle        = form.querySelector('[data-cnm-sub-toggle]');
    var subCheckbox      = form.querySelector('[data-cnm-sub-checkbox]');
    var subPill          = form.querySelector('[data-cnm-sub-pill]');
    var sizeBtns         = Array.prototype.slice.call(form.querySelectorAll('[data-cnm-size]'));
    var cards            = Array.prototype.slice.call(form.querySelectorAll('[data-cnm-pack]'));
    var fitHint          = form.querySelector('[data-cnm-fit-hint]');
    var mainImg          = root.querySelector('.cnm-hero__image');
    var thumbs           = Array.prototype.slice.call(root.querySelectorAll('[data-cnm-thumb]'));

    function setMainImage(url) {
      if (!mainImg || !url) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = url;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        setMainImage(t.getAttribute('data-full'));
      });
    });

    var sellingPlanId    = root.dataset.sellingPlanId || '';
    var hasSubscription  = root.dataset.hasSubscription === 'true';

    var activeSize = sizeBtns.filter(function (b) { return b.classList.contains('is-active'); })[0];
    var selCard    = cards.filter(function (c) { return c.classList.contains('is-selected'); })[0];
    var currentSize = (activeSize || sizeBtns[0] || {}).dataset ? (activeSize || sizeBtns[0]).dataset.cnmSize : '';
    var currentPack = (selCard || cards[cards.length - 1] || {}).dataset ? (selCard || cards[cards.length - 1]).dataset.cnmPack : '';
    var isSubscribed = hasSubscription && subCheckbox ? subCheckbox.checked : false;

    function findVariant(size, pack) {
      var exact = variants.filter(function (v) { return v.size === size && v.pack === pack; })[0];
      if (exact) return exact;
      // tolerant fallbacks so the picker still works if naming drifts
      return variants.filter(function (v) { return v.pack === pack; })[0] || null;
    }
    function onePackPrice(size) {
      var v = variants.filter(function (x) { return x.size === size && packCount(x.pack) === 1; })[0]
           || variants.filter(function (x) { return packCount(x.pack) === 1; })[0];
      return v ? v.price : 0;
    }

    function updateFitHint() {
      if (!fitHint) return;
      var a = sizeBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || sizeBtns[0];
      if (a && a.dataset.cnmHint) fitHint.textContent = a.dataset.cnmHint;
    }

    function renderCards() {
      var base = onePackPrice(currentSize);
      cards.forEach(function (card) {
        var pack = card.dataset.cnmPack;
        var n = packCount(pack);
        var v = findVariant(currentSize, pack);
        var priceEl   = card.querySelector('[data-cnm-card-price]');
        var cptEl     = card.querySelector('[data-cnm-card-cpt]');
        var perPackEl = card.querySelector('[data-cnm-card-perpack]');
        var saveEl    = card.querySelector('[data-cnm-card-save]');
        if (!v) { card.hidden = true; return; }
        card.hidden = false;
        card.dataset.cnmVariantId = v.id;
        card.dataset.cnmPrice = v.price;
        if (priceEl)   priceEl.textContent = money(v.price);
        if (cptEl) {
          if (v.cpt && v.cpt > v.price) { cptEl.hidden = false; cptEl.textContent = money(v.cpt); }
          else { cptEl.hidden = true; }
        }
        if (perPackEl) perPackEl.textContent = money(v.price / n) + '/pack';
        if (saveEl) {
          // Prefer the compare-at basis (one consistent reference across the ladder);
          // fall back to per-pack-vs-single if no compare-at is set.
          var pct = 0;
          if (v.cpt && v.cpt > v.price) { pct = Math.round((1 - v.price / v.cpt) * 100); }
          else if (base > 0) { pct = Math.round((1 - (v.price / n) / base) * 100); }
          if (pct >= 1) { saveEl.hidden = false; saveEl.textContent = 'SAVE ' + pct + '%'; }
          else { saveEl.hidden = true; }
        }
        if (v.available === false) { card.setAttribute('data-cnm-soldout', 'true'); }
        else { card.removeAttribute('data-cnm-soldout'); }
      });
    }

    function refreshPrice() {
      var v = findVariant(currentSize, currentPack);
      var raw = v ? v.price : 0;
      var shown = isSubscribed ? Math.round(raw * (1 - SUB_DISCOUNT)) : raw;
      if (priceDisplay) priceDisplay.textContent = money(shown);
      if (youPay) {
        var cpt = v && v.cpt ? v.cpt : 0;
        if (!v || raw === 0) { youPay.hidden = true; }
        else if (isSubscribed) {
          var offRrp = (cpt > shown ? cpt : raw) - shown;
          youPay.innerHTML = 'You pay <strong>' + money(shown) + '</strong> today \u2014 that\u2019s <strong>' + money(offRrp) + ' off RRP</strong>, and you never run out.';
          youPay.hidden = false;
        } else if (cpt > raw) {
          youPay.innerHTML = 'You save <strong>' + money(cpt - raw) + '</strong> vs RRP. Tick Subscribe &amp; Save for 20% more off.';
          youPay.hidden = false;
        } else { youPay.hidden = true; }
      }
      if (variantInput && v) variantInput.value = v.id;
      if (subPill) subPill.hidden = !isSubscribed;
      root.dispatchEvent(new CustomEvent('cnm:variant:change', {
        bubbles: true,
        detail: { variantId: v ? v.id : null, price: shown, rawPrice: raw, isSubscribed: isSubscribed }
      }));
    }

    function selectPack(pack) {
      currentPack = pack;
      cards.forEach(function (c) {
        var on = c.dataset.cnmPack === pack;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      refreshPrice();
    }

    function selectSize(size) {
      currentSize = size;
      sizeBtns.forEach(function (b) {
        var on = b.dataset.cnmSize === size;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      updateFitHint();
      renderCards();
      refreshPrice();
      var vImg = findVariant(currentSize, currentPack);
      if (vImg && vImg.img) { setMainImage(vImg.img); thumbs.forEach(function (x) { x.classList.remove('is-active'); }); }
    }

    function setSubscription(on) {
      isSubscribed = !!on;
      if (subToggle) subToggle.classList.toggle('is-checked', isSubscribed);
      if (subCheckbox) subCheckbox.checked = isSubscribed;
      if (sellingPlanInput) sellingPlanInput.value = isSubscribed ? sellingPlanId : '';
      refreshPrice();
    }

    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { selectSize(b.dataset.cnmSize); }); });
    cards.forEach(function (c) { c.addEventListener('click', function () { selectPack(c.dataset.cnmPack); }); });
    if (subToggle && hasSubscription) {
      subToggle.addEventListener('click', function (e) { if (e.target.matches('input')) return; setSubscription(!isSubscribed); });
      if (subCheckbox) subCheckbox.addEventListener('change', function () { setSubscription(subCheckbox.checked); });
    }

    // Init
    updateFitHint();
    renderCards();
    refreshPrice();
    setSubscription(isSubscribed);
  }

  function initAll() {
    document.querySelectorAll('[data-cnm-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cnm-hero]');
    if (root) initHero(root);
  });
})();
